import React, {   } from "react";
import { Form, Col } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';

export default function SettingLayout(props) {
    const questionIndex = props.index;
    const data = props.data || 0;
    const dispatch = useDispatch();
    // console.log(props);

    function onSelect(e) {
        try{
            let tmp = parseInt(e.currentTarget.value);
            if( false==isNaN(tmp) ){
                console.log(tmp);
                dispatch({ 
                    type: "QUESTION_SET_LAYOUT", 
                    index: questionIndex, 
                    data: tmp });
            }
        } catch(e){

        }
    }

    function render() {
        return (
            <Form className="mt-1">
                <Col className="text-left">
                    <Form.Check onChange={onSelect} type="radio" checked={data==0} name={questionIndex+"no-rand"} value="0" label="條列"/>
                </Col>
                <Col className="text-left">
                    <Form.Check onChange={onSelect} type="radio" checked={data==1} name={questionIndex+"no-rand"} value="1" label="並排"/>
                </Col>
            </Form>
        );
    }

    return render();
}
